module.exports = __webpack_public_path__ + "img/RedMetallic_A.656c366e.png";